module.exports = __webpack_public_path__ + "img/arrow_back.efb2a9df.svg";